module.exports = __webpack_public_path__ + "assets/img/service-QRcord-hq.4b7cc309.jpg";